{
    "menu":{
        "realTime":"Real-Time",
        "alerts":"Alerts",
        "history":"History",
        "licensePlates":"Alert Registration",
        "events":"Events",
        "tooltip":{
            "alertHistory":"History",
            "plateRegistration":"Alert Registration"
        }
    },
    "headerMenu":{
        "logOut":"Log Out",
        "changePassword":"Change Password",
        "languageOptions":{
            "portuguese":"Portuguese",
            "spanish":"Spanish",
            "english":"English"
        }
    },
    "shared":{
        "filter":{
            "filterLabel":"Filter",
            "filterCleanLabel":"Clear Filters",
            "filterMostRecent":"Most Recent",
            "filterSelectOption":"Select an option",
            "filterOlder":"Older",
            "filterPlate":"License plate",
            "filterEquipment":"Equipment",
            "filterAlertType":"Alert Type",
            "filterShowAll":"Show all",
            "registrationDate":"Registration Date",
            "deadline":"Deadline",
            "filterSelectedAlertType":"selected reason",
            "filterSelectedAlertsType":"selected reasons"
        },
        "placeholder":{
            "select":"Select",
            "selectDeadline":"Select a deadline"
        },
        "details":{
            "detailsTitle":"Alert Details",
            "remarks":"Remarks",
            "save":"Save"
        },
        "table":{
            "detail":"Detail",
            "pageReport":"Showing {first} to {last} of {totalRecords} records"
        },
        "labels":{
            "alertsLabel":" alerts",
            "motiveLabels":{
                "licensingDelay":"Licensing Delay",
                "crime":"Crime",
                "ipvaDelay":"IPVA Delay",
                "boxTruck":"Box",
                "tankWithLiquids":"Tank with Liquids",
                "concretePipe":"Concrete Pipe",
                "metal":"Metal",
                "stone":"Stone",
                "logOfWood":"Log of Wood",
                "wood":"Wood",
                "brick":"Brick",
                "rockParticles":"Rock Particles",
                "glass":"Glass",
                "gasCylinder":"Gas Cylinder",
                "dumpster":"Dumpster",
                "container":"Container"
            },
            "alert":"Alert",
            "plate":"License Plate",
            "dateAndHour":"Date and Time",
            "registrationDate":"Registration Date",
            "location":"Location",
            "address":"Address",
            "direction":"Direction",
            "lane":"Lane",
            "equipment":"Equipment",
            "plateRule":"License Plate Rule",
            "weight":"Weight",
            "userFeedback":"User Feedback",
            "reason":"Reason",
            "status":"Status",
            "deadline":"Deadline",
            "interval":"Interval",
            "register":"Register",
            "confirmation":"Confirmation",
            "name":"Name",
            "yes":"Yes",
            "no":"No",
            "confirm":"Confirm",
            "cancel":"Cancel",

            "ia":"AI",
            "brand":"Brand",
            "model":"Model",
            "city":"City",
            "color":"Color",
            "state":"State",
            "disabled":"Disabled",
            "publicSecurityIntegration":"Public Security Integration",
            "confiability":"Confiability AI",
            "ia-load":"Load AI",
            "ia-helmet":"Helmet AI",
            "ia-classification":"Classification",
            "ia-metadados":"Metadados"
        }
    },
    "calendar": {
        "dayNames": {
          "sunday": "Sunday",
          "monday": "Monday",
          "tuesday": "Tuesday",
          "wednesday": "Wednesday",
          "thursday": "Thursday",
          "friday": "Friday",
          "saturday": "Saturday"
        },
        "dayNamesShort": {
          "sun": "Sun",
          "mon": "Mon",
          "tue": "Tue",
          "wed": "Wed",
          "thu": "Thu",
          "fri": "Fri",
          "sat": "Sat"
        },
        "dayNamesMin": {
          "su": "Su",
          "mo": "Mo",
          "tu": "Tu",
          "we": "We",
          "th": "Th",
          "fr": "Fr",
          "sa": "Sa"
        },
        "monthNames": {
          "january": "January",
          "february": "February",
          "march": "March",
          "april": "April",
          "may": "May",
          "june": "June",
          "july": "July",
          "august": "August",
          "september": "September",
          "october": "October",
          "november": "November",
          "december": "December"
        },
        "monthNamesShort": {
          "jan": "Jan",
          "feb": "Feb",
          "mar": "Mar",
          "apr": "Apr",
          "may": "May",
          "jun": "Jun",
          "jul": "Jul",
          "aug": "Aug",
          "sep": "Sep",
          "oct": "Oct",
          "nov": "Nov",
          "dec": "Dec"
        },
        "dateFormat": "mm/dd/yy",
        "emptyMessage": "No Response"
    },
    "login":{
        "subTitle":"Active surveillance for smart cities",
        "password":"Password",
        "logIn":"Log In",
        "loginError":"Failed to log in",

        "authServerCommunicationFail": "Failed to communicate with the authentication server.",
        "invalidRequest": "Invalid request. Please check the provided data.",        
        "invalidCredentials": "Incorrect email or password.",
        "noPermissionAdmin": "User does not have permission to access the Administrator.",
        "authInternalError": "Internal error in the authentication service.",
        "authServiceUnavailable": "Authentication service is temporarily unavailable."
    },
    "realTime":{
        "empty_1": "Select in",
        "empty_2": "the desired camera(s) to display the video streaming",
        "toolbar":{
            "videoWallTooltip":"View the video wall in full screen",
            "showInfoTooltip":"Show/Hide camera information bar",
            "videoWallConfig":"Video wall settings",
            "videoWallOneDevice":"Change the video wall to 1 device",
            "videoWallFourDevices":"Change the video wall to 4 devices",
            "info":"Select one or more devices to activate the actions",
            "videoWallConfigModal":{
                "title":"Video Wall Settings",
                "rotate":"Rotate",
                "seconds":"Seconds",
                "update":"Update"
            }
        },
        "deviceSideBar":{
            "selected":"Selected:",
            "cameras":"Cameras"
        },
        "groupSideBar":{
            "new":"New",
            "editGroup":"Edit group",
            "removeGroup":"Remove group",
            "addOrRemove":"Add/Remove from carousel",
            "toast":{
                "successGroupRegistered":"Group successfully registered",
                "dywRemoveGroup":"Do you really want to remove the group?",
                "successGroupDeleted":"Group successfully deleted",
                "successGroupEdited":"Group successfully edited",
                "successDeviceDeleted":"Device successfully deleted"
            },
            "createOrEditModal":{
                "newGroup":"New Group",
                "editGroup":"Edit Group"
            }
        },
        "buttons": {
            "devices":"Devices",
            "devicesTooltip":"Select devices",
            "groups":"Groups",
            "selectGroups":"Select groups"
        },
        "toast":{
            "infoTitle":"Information",
            "minimalDevices":"This configuration will be available when at least 5 devices are selected",
            "disabledF11":"The \"F11\" button that executes the full-screen function has been disabled on this page. To view the video wall in full screen, click the indicated button"
        }
    },

    "alert":{
        "toolbar":{
            "noneAlert":"No active alerts",
            "activeAlert":" Active alert",
            "activeAlerts":" Active alerts",
            "pauseTooltip":"Pause the update of new alerts on screen",
            "startTooltip":"Resume the update of new alerts on screen"
        },
        "toast":{
            "attentionTitle":"Attention!",
            "errorTitle":"Error!",
            "successTitle":"Success!",
            "warnTitle":"Warning!",
            "noAlert":"No alerts found",
            "errorGetAlert":"Failed to fetch the list of alerts",
            "errorGetMotive":"Error fetching reasons",
            "feedbackError": "To send feedback, it is necessary to provide the reason",
            "feedbackSuccess":"Feedback sent"
        }
    },
    "alertHistory":{
        "toolbar":{
            "alertHistory":"History"
        }
    },
    "plates":{
        "toolbar":{
            "licensePlateRegistration":"Alert Registration",
            "uploadTooltip":"Attach alert file"
        },
        "toast":{
            "errorGetPlate":"Error fetching alerts!",
            "fourAsterisksError":"No more than 4 asterisks are allowed",
            "validPlateError":"Enter a valid alert",
            "oneOrMoreReasonsError":"Select one or more reasons",
            "noDeadlineError":"Select a deadline",
            "getRulesError":"Error fetching existing rules",
            "importSuccess":"Alerts imported successfully!",
            "somePlates":"Some alerts were not imported!",
            "errorImportingPlates":"Error importing alerts!",
            "requestError":"Request error"
        },
        "registerDialog":{
            "dywRegister":"Do you want to register the license plate {{plate}} with {{theReasons}}",
            "theReason":" the reason",
            "theReasons":" the reasons",
            "and":" and ",
            "withinPeriod":" within the period ",
            "plate":"License plate ",
            "plateRegistered":"License plate {{plate}} with {{theReasons}}",
            "successRegistered":" successfully registered!",
            "registerError":"Error registering license plate!",
            "alreadyAnActiveRule":"There is already an active rule for the license plate {{plate}}, for the reason {{reason}}, in the period from {{startDate}} to {{endDate}}<br>Do you want to overwrite?",
            "operationCanceled":"Operation canceled for license plate {{plate}}, reason '{{reason}}'"
        },
        "uploadDialog":{
            "attachPlateFile":"Attach plate file",
            "attentionFormat":"Attention: the attached file must follow the example file format",
            "buttons":{
                "choose":"Choose",
                "cancel":"Cancel",
                "exampleFile":"Example File"
            },
            "uploadError":"Your file was not accepted due to the errors listed below. Please correct them to upload successfully",
            "errorList":{
                "column":"Column ",
                "line":" Line "
            }
        },
        "table":{
            "activeDialog":{
                "dywActive":"Do you want to {{option}} the license plate {{plate}}?",
                "activate":"activate",
                "deactivate":"deactivate",
                "activated":"activated",
                "deactivated":"deactivated",
                "activeSuccess":"License plate {{option}} successfully!",
                "activeError":"Error {{option}} the license plate!"
            },
            "reasonDeactivation":"Reason for deactivation"
        }
    },
    "events":{
        "toolbar":{
            "events":"Events"
        },
        "details":{
            "detailsTitle":"Event Details",
            "hasAlert":"This passage has an alert"
        },
        "toast":{
            "getEventError":"Error fetching events!"
        }
    }
}
